export default __webpack_public_path__ + "static/media/app-version-blue.5146788a.svg";